var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("node", {
    attrs: {
      title: "发起人",
      "is-root": true,
      content: _vm.content,
      isProcess: _vm.isProcess,
      placeholder: "所有人",
      "header-bgc": _vm.headerBgc,
      "header-icon": "el-icon-user-solid",
    },
    on: {
      selected: function ($event) {
        return _vm.$emit("selected")
      },
      insertNode: (type) => _vm.$emit("insertNode", type),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }